import { IMingaFeatureToggleKeys } from 'libs/domain';
import { MingaPermission } from 'libs/domain';

import { ModalOverlayPrimaryHeaderBackground } from '@shared/components/modal-overlay';
import { getAppColor } from '@shared/constants';

import { SaAssignOverlayConfig, SaSelectorTypes } from '../types';

export const DEFAULT_ROUTE = '/landing/email';

export enum SelectionAssignerRoutes {
  ROOT = 'selection-assigner',
  HALL_PASS = 'hall-pass',
  BEHAVIOR = 'behavior',
  CHECK_IN = 'checkin',
}

// If using a button toggle group within the modal,
// define a tabbed header config (ex. behaviorModalConfig)
const behaviorModalConfig: SaAssignOverlayConfig = {
  formTitle: 'Assign Behavior',
  formHeaderBg: ModalOverlayPrimaryHeaderBackground.GREEN,
  tabbedHeader: true,
  data: [
    {
      carouselTitle: 'Select a behavior',
      selector: 'praise',
      title: 'Praise',
      icon: 'mg-behavior-praise',
      color: getAppColor('behavior-praise'),
      filterField: false,
      filterInfo: {
        filterPlaceholder: '',
        filterEmptyHeading: 'No Praises found',
        filterEmptyMsg: 'Active Praises will appear here',
      },
    },
    {
      carouselTitle: 'Select a behavior',
      selector: 'guidance',
      title: 'Guidance',
      icon: 'mg-behavior-guidance',
      color: getAppColor('behavior-consequence'),
      filterField: false,
      filterInfo: {
        filterPlaceholder: '',
        filterEmptyHeading: 'No Guidances found',
        filterEmptyMsg: 'Active Guidances will appear here',
      },
    },
    {
      carouselTitle: 'Select a consequence',
      selector: 'consequence',
      title: 'Consequence',
      icon: 'mg-behavior-menu',
      color: getAppColor('behavior-praise'),
      filterField: false,
      filterInfo: {
        filterPlaceholder: '',
        filterEmptyHeading: 'No Consequences found',
        filterEmptyMsg: 'Active Consequences will appear here',
      },
    },
  ],
};

const checkinModalConfig: SaAssignOverlayConfig = {
  formTitle: 'Assign Check in',
  formHeaderBg: ModalOverlayPrimaryHeaderBackground.TEAL,
  tabbedHeader: true,
  data: [
    {
      carouselTitle: 'Select a check in',
      selector: 'checkin',
      title: 'Check in',
      icon: 'mg-checkin-menu',
      color: getAppColor('check-in'),
      filterField: false,
      filterInfo: {
        filterPlaceholder: '',
        filterEmptyHeading: 'No Check in reasons found',
        filterEmptyMsg: 'Active Check in reasons will appear here',
      },
    },
    {
      carouselTitle: 'Select a flex activity',
      selector: 'flex-activity',
      title: 'Flex Activity',
      icon: 'mg-flextime-menu',
      color: getAppColor('flextime'),
      filterField: true,
      filterInfo: {
        filterPlaceholder: 'FlexTime Period',
        filterEmptyHeading: 'No Activities found',
        filterEmptyMsg: "Looks like you don't have any activities to check in users to",
      },
      permissions: [
        MingaPermission.FLEX_TIME_MANAGE,
        MingaPermission.FLEX_TIME_REGISTER_FOR_ACTIVITY,
        MingaPermission.FLEXTIME_MANAGE_OWN_ACTIVITY,
      ],
      requiredModule: IMingaFeatureToggleKeys.FLEX_TIME_ENABLED,
    },
  ],
};

/** Add any additional modal configurations to this list */
export const SELECTION_ASSIGNER_MODAL_CONFIG: Record<SaSelectorTypes, SaAssignOverlayConfig> = {
  ['hall-pass']: {
    formTitle: 'Assign Hall Pass',
    selfAssignTitle: 'Create Hall Pass',
    formHeaderBg: ModalOverlayPrimaryHeaderBackground.PINK,
    tabbedHeader: false,
    data: {
      carouselTitle: 'Select a pass type',
      filterField: false,
      filterInfo: {
        filterPlaceholder: '',
        filterEmptyHeading: 'No Hall Pass available',
        filterEmptyMsg: 'Active Hall Pass types will appear here',
      },
    },
  },
  ['praise']: { ...behaviorModalConfig },
  ['guidance']: { ...behaviorModalConfig },
  ['consequence']: { ...behaviorModalConfig },
  ['checkin']: { ...checkinModalConfig },
  ['flex-activity']: { ...checkinModalConfig },
};
